import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { MessageSquare, Loader2, ShoppingCart } from "lucide-react";
import { useSelector } from "react-redux";
import { openAuthDialog } from "../../store/auth/authSlice";
import PartPaymentModal from "../Modal/PartPaymentModal";

const ChatButton = ({
  onChatClick,
  isLoading,
  part,
  onOpenChange: controlledOnOpenChange
}) => {
  const { user } = useSelector((state) => state.auth);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [internalIsOpen, setInternalIsOpen] = useState(false);
  const setIsOpen = controlledOnOpenChange || setInternalIsOpen;
  const [partDetail, setPartDetail] = useState();

  if (user?.role === "seller") {
    return null;
  }

  const handleBuyClick = (part) => {
    if (!isAuthenticated || !user) {
      if (!isAuthenticated) {
        toast({
          title: "Login Required",
          description: "Please login as buyer to buy Parts.",
          variant: "destructive"
        });
        dispatch(
          openAuthDialog({
            showLoginFirstOrOnSuccess: true,
            redirectPage: window.location.pathname,
            onSuccessfulAuth: () => setIsOpen(true)
          })
        );
      }
      return;
    }
    if (!part?.stripePaymentLink) {
      toast({
        title: "Payment Unavailable",
        description: "This seller has not added a Stripe payment link.",
        variant: "destructive"
      });
      return;
    }
    setPartDetail(part);
    setShowPaymentModal(true);
  };

  return (
    <div className="w-full p-3 pt-1.5 border-t border-border/50 mt-auto">
      <Button
        onClick={onChatClick}
        variant="outline"
        size="sm"
        className="w-full group"
        disabled={isLoading}
      >
        <MessageSquare className="mr-1.5 h-3 w-3 group-hover:animate-pulse" />
        Chat
      </Button>
      {part?.stripePaymentLink &&
        part?.stripePaymentLink !== "" &&
        user?.role !== "seller" && (
          <Button
            variant="default"
            size="sm"
            className="w-full group bg-primary text-white hover:bg-primary/70"
            onClick={(e) => {
              e.stopPropagation();
              handleBuyClick();
            }}
          >
            <ShoppingCart className="mr-2 h-4 w-4 group-hover:scale-110 transition-transform" />
            Buy Now
          </Button>
        )}
      {showPaymentModal && (
        <PartPaymentModal
          open={showPaymentModal}
          part={partDetail}
          close={(isOpen) => {
            if (!isOpen) {
              setShowPaymentModal(false);
              setPartDetail(null);
            }
          }}
        />
      )}
    </div>
  );
};

export default ChatButton;
